/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Cmp_R_MaturityInputs */

const en_mk_cmp_r_maturity = /** @type {(inputs: Mk_Cmp_R_MaturityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Product maturity`)
};

const id_mk_cmp_r_maturity = /** @type {(inputs: Mk_Cmp_R_MaturityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kematangan produk`)
};

/**
* | output |
* | --- |
* | "Product maturity" |
*
* @param {Mk_Cmp_R_MaturityInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_cmp_r_maturity = /** @type {((inputs?: Mk_Cmp_R_MaturityInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Cmp_R_MaturityInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_cmp_r_maturity(inputs)
	return en_mk_cmp_r_maturity(inputs)
});